import React from 'react';
import {Helmet} from 'react-helmet-async';

import {ButtonGroup, LogoHp} from '@veneer/core';

import {Section} from '../Layout';

import useStyles from './styles';

const PageTitle = ({
    htmlTitle,
    title,
    subtitle,
    centered = false,
    logo = false,
    pageActions,
}: {
    htmlTitle?: string;
    title: string;
    subtitle?: string;
    centered?: boolean;
    logo?: boolean;
    pageActions?: React.ReactNode;
}) => {
    const styles = useStyles(centered, !!pageActions);
    return (
        <div>
            {logo && centered && (
                <Section className={styles.logo}>
                    <LogoHp
                        data-testid="logo"
                        appearance="singlecolor"
                        size={48}
                    />
                </Section>
            )}
            <Section>
                <Helmet title={htmlTitle || title} />
                <div className={styles.headingWrapper}>
                    <h1 className={`${styles.heading} title-regular`}>{title}</h1>
                    {pageActions && <ButtonGroup>{pageActions}</ButtonGroup>}
                </div>
                {subtitle && <p className={styles.subheading}>{subtitle}</p>}
            </Section>
        </div>
    );
};

export default PageTitle;
